import en from './locales/en.json' with { type: 'json' };
import sv from './locales/sv.json' with { type: 'json' };

export const DEFAULT_LOCALE = 'en';

/** i18next-compatible resources. English is the source of truth for keys. */
export const resources = {
  en: { translation: en },
  sv: { translation: sv },
} as const;

export type TranslationKeys = typeof en;
